module.exports = __webpack_public_path__ + "static/media/bg-6.502d8a93.png";